<template>
  <div>
    <form class="login-form" @submit.prevent="submitForm">
      <h2>{{ $t('login.TITLE') }}</h2>
      <BaseInput
        :label="$t('login.label.EMAIL')"
        :placeholder="$t('login.EMAIL_PLACEHOLDER')"
        v-model="credentials.email"
        type="email"
        autocomplete="username"/>
      <BaseInput
        :label="$t('login.label.PASSWORD')"
        :placeholder="$t('login.PASSWORD_PLACEHOLDER')"
        v-model="credentials.password"
        type="password"
        autocomplete="current-password"/>
      <div v-if="errors.length" class="errors-container">
        <ul>
          <li
            class="error"
            v-for="error in errors"
            :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
      <div class="submit-container">
        <input class="primary-button" type="submit" :value="$t('login.SUBMIT_BUTTON')">
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      credentials: this.newCredentials(),
      errors: []
    }
  },
  methods: {
    newCredentials () {
      return {
        email: '',
        password: ''
      }
    },
    checkForm () {
      this.errors = []

      if (!(this.credentials.email && this.credentials.password)) {
        this.errors.push(this.$t('login.error.FIELD_REQUIRED'))
      }

      return !this.errors.length
    },
    submitForm () {
      const formValid = this.checkForm()

      if (formValid) {
        this.login(this.credentials)
          .then(data => {
            this.setUserData(data)
            this.$router.push({ name: 'Exams' })
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.errors.push(this.$t('login.error.INVALID_CREDENTIALS'))
            }
          })
      }
    },
    ...mapActions([
      'login',
      'setUserData'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/base";

.login-form {
  @extend .form;

  max-width: 400px;
}

</style>
